import { Injectable } from '@angular/core';
import {
  GebaeudeAufGrundstueckDetailEntryMeta,
  GebaeudeEingangAdresseMasterDetailEntryMeta,
  GebaeudeEingangAdresseVersionDetailEntryMeta,
  GebaeudeMasterDetailEntryMeta,
  GebaeudeVersionDetailEntryMeta,
  GrundstueckListEntry
} from '../../../core/av-api';
import { ComparatorService } from '../comparator-service';
import { GrundstueckId } from '../../../core/gb-api';
import { GebaeudeVersionDetailEntryVm } from './gebaeude-version-detail-entry-vm';
import GrundstueckArtEnum = GrundstueckListEntry.GrundstueckArtEnum;

@Injectable({
  providedIn: 'root'
})
export class GebaeudeMasterDetailEntryVmService {
  gebaeudeVersionsVm: GebaeudeVersionDetailEntryVm[];
  filteredGebaeudeAufGrundstueck: GebaeudeAufGrundstueckDetailEntryMeta[];

  constructor(
    public model: GebaeudeMasterDetailEntryMeta,
    private versions: GebaeudeVersionDetailEntryMeta[],
    private comparatorService: ComparatorService,
    private grundstueckId: GrundstueckId,
    private publicMode: boolean
  ) {
    model.eingangAdressen = this.sortedEingangAdressen(model.eingangAdressen);
    this.filteredGebaeudeAufGrundstueck = this.filterGebaeudeAufGrundstueck(
      model.gebaeudeAufGrundstueck,
      model.gebaeudeAufGrundstueckGehoertZuSdr,
      this.grundstueckId
    );
    this.gebaeudeVersionsVm = this.calculateGebaeudeVersions();
  }

  get lastVersion(): GebaeudeVersionDetailEntryVm {
    for (const version of this.gebaeudeVersionsVm) {
      if (version.lastVisible) {
        return version;
      }
    }
  }

  get getRelevantEingangsAdresse(): GebaeudeEingangAdresseVersionDetailEntryMeta {
    let adresseMaster = this.model.eingangAdressen.filter((a) => a.histInfo.bisTimePoint)[0];
    if (!adresseMaster) {
      adresseMaster = this.model.eingangAdressen[0];
    }
    return adresseMaster?.versions[adresseMaster?.versions.length - 1];
  }

  private calculateGebaeudeVersions(): Array<GebaeudeVersionDetailEntryVm> {
    const VersionsVm = new Array<GebaeudeVersionDetailEntryVm>();
    if (this.versions) {
      for (let i = 0; i < this.versions.length; i++) {
        VersionsVm.push(
          new GebaeudeVersionDetailEntryVm(
            this.versions[i],
            this.sortedGebaeudeAufGrundstueckZuVersion(this.versions[i], this.filteredGebaeudeAufGrundstueck),
            i === this.versions.length - 1,
            this.getNrOfGrundstueckeOfArt(GrundstueckArtEnum.LIEGENSCHAFT, this.model.gebaeudeAufGrundstueck),
            this.getNrOfGrundstueckeOfArt(GrundstueckArtEnum.SDR, this.model.gebaeudeAufGrundstueck)
          )
        );
      }
    }
    return VersionsVm;
  }

  private getNrOfGrundstueckeOfArt(grundstueckArt: GrundstueckArtEnum, gebAufGsArr: GebaeudeAufGrundstueckDetailEntryMeta[]) {
    let anzahlLIG = 0;
    for (const gebAufGs of this.filterRechtsgueltig(gebAufGsArr)) {
      if (gebAufGs.grundstueck?.grundstueckArt === grundstueckArt) {
        anzahlLIG += 1;
      }
    }
    return anzahlLIG;
  }

  private filterRechtsgueltig(gebAufGsArr: GebaeudeAufGrundstueckDetailEntryMeta[]) {
    return gebAufGsArr.filter((gag) => !gag.histInfo.bisTimePoint);
  }

  private filterGebaeudeAufGrundstueck(
    gebaeudeAufGrundstueck: GebaeudeAufGrundstueckDetailEntryMeta[],
    gehoertZuSdr: GebaeudeAufGrundstueckDetailEntryMeta[],
    grundstueckId: GrundstueckId
  ) {
    if (this.publicMode) {
      return gebaeudeAufGrundstueck;
    }
    if (gebaeudeAufGrundstueck.some((g) => g.grundstueck.id.id === grundstueckId.id)) {
      return gebaeudeAufGrundstueck.filter((gag) => gag.grundstueck?.id?.id === grundstueckId?.id);
    } else {
      return gehoertZuSdr.filter((gag) => gag.grundstueck?.id?.id === grundstueckId?.id);
    }
  }

  private sortedEingangAdressen(adressen: GebaeudeEingangAdresseMasterDetailEntryMeta[]) {
    return adressen.sort((a, b) => {
      return this.comparatorService.eingangadressenMasterDetailComparator(a, b);
    });
  }

  private sortedGebaeudeAufGrundstueckZuVersion(
    version: GebaeudeVersionDetailEntryMeta,
    filteredGebaeudeAufGrundstueck: GebaeudeAufGrundstueckDetailEntryMeta[]
  ) {
    return this.getGebaeudeAufGrundstueckZuGebaeudeVersion(version, filteredGebaeudeAufGrundstueck).sort((a, b) => {
      return this.comparatorService.erstellzeitpunktComparator(a, b);
    });
  }

  private getGebaeudeAufGrundstueckZuGebaeudeVersion(
    version: GebaeudeVersionDetailEntryMeta,
    filteredGebaeudeAufGrundstueck: Array<GebaeudeAufGrundstueckDetailEntryMeta>
  ): Array<GebaeudeAufGrundstueckDetailEntryMeta> {
    let arrayGebAufGs: Array<GebaeudeAufGrundstueckDetailEntryMeta>;
    arrayGebAufGs = new Array<GebaeudeAufGrundstueckDetailEntryMeta>();
    for (const gebAufGs of filteredGebaeudeAufGrundstueck) {
      for (const gebaeude of gebAufGs.gebaeude) {
        if (gebaeude.id === version.id.id) {
          arrayGebAufGs.push(gebAufGs);
        }
      }
    }
    return arrayGebAufGs;
  }
}
